export function getBase64(file: File, callback: ((result) => void)) {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
        callback(reader.result);
    };
    reader.onerror = function (error) {
        console.error(error);
    };
}

export function getArrayBuffer(file: File, callback: ((result) => void)) {
    const reader = new FileReader();
    reader.readAsArrayBuffer(file);
    reader.onload = function () {
        callback(reader.result);
    };
    reader.onerror = function (error) {
        console.error(error);
    };
}